import { parseOccurrenceTimingWrite, parseScheduleFields } from '@liquid-spirit/date-time/validation';

const timingFields = ['timingVersion', 'timingRevision', 'timeZone', 'localStart', 'localEnd', 'startsAt', 'endsAt'];

export const isCalendarTimingProjection = value => {
  try {
    const parsed = parseOccurrenceTimingWrite(value);
    return !!parsed.calendarTiming && value.timingVersion === 1
      && Number.isSafeInteger(value.timingRevision) && value.timingRevision >= 1
      && value.timeZone !== undefined
      && ['localStart', 'localEnd', 'startsAt', 'endsAt'].every(key => value[key] === null)
      && value.calendarTiming.endDateExclusive === parsed.calendarTiming.endDateExclusive
      && value.date === `${parsed.calendarTiming.startDate}T00:00:00.000Z`;
  } catch { return false; }
};

/** Additive during migration; a projection must carry the complete canonical interval. */
export const isSessionTimingProjection = value => {
  if (value.calendarTiming != null) return isCalendarTimingProjection(value) && value.time === null;
  if (!timingFields.some(key => Object.hasOwn(value, key))) return true;
  try {
    parseOccurrenceTimingWrite(value);
    return value.timingVersion === 1 && Number.isSafeInteger(value.timingRevision) && value.timingRevision >= 1
      && timingFields.every(key => value[key] !== undefined)
      && (value.endsAt === null) === (value.localEnd === null)
      && (value.endsAt === null || new Date(value.endsAt) > new Date(value.startsAt))
      && value.time === value.localStart.time
      && value.date === `${value.localStart.date}T00:00:00.000Z`;
  } catch { return false; }
};

export const isActivityScheduleProjection = value => {
  if (!Object.hasOwn(value, 'localSchedule') && !Object.hasOwn(value, 'scheduleRevision')) return true;
  try {
    parseScheduleFields(value.localSchedule);
    return Number.isSafeInteger(value.scheduleRevision) && value.scheduleRevision >= 1
      && value.groupDetails?.time === value.localSchedule.startTime;
  } catch { return false; }
};
